import './registerServiceWorker'
function onDeviceReady() {
  if (WEB_ONLY) {
    return import('./main-web');
  } else {
    return import('./main-deviceready');
  }
}

if (
  /(iPad|iPhone|iPod)/g.test(navigator.userAgent)
  || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
) {
  document.body.classList.add('is-ios');
}

if (window.cordova) {
  document.addEventListener('deviceready', onDeviceReady, false);
} else {
  document.addEventListener('DOMContentLoaded', onDeviceReady, false);
}
